module.exports = __webpack_public_path__ + "static/media/Body on Fire (with Maya Isac).a59f626c.jpg";